import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AiEditStore } from '../../../services/ai-edit.store';

/**
 * Nota no cabeçalho da prévia no modo "Editar com IA": "Nenhuma alteração ainda" enquanto a
 * IA pensa (estado 2, a folha está intacta) e "IA editando" enquanto ela aplica (estado 3,
 * ao lado do spinner de repaginação que o painel já tem).
 */
@Component({
    selector: 'ai-edit-preview-note',
    imports: [TranslatePipe],
    template: `
        @switch (store.stage()) {
            @case ('thinking') {
                <span class="note">{{ 'document.edit.aiEdit.previewNoChanges' | translate }}</span>
            }
            @case ('applying') {
                <span class="note note--active">{{ 'document.edit.aiEdit.previewAiEditing' | translate }}</span>
            }
        }
    `,
    styles: `
        :host {
            display: inline-flex;
            min-width: 0;
        }

        .note {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: var(--contentTertiary);
            font-size: 0.75rem;
        }

        .note--active {
            color: var(--primary);
            font-weight: 500;
        }
    `,
})
export class AiEditPreviewNoteComponent {
    public store = inject(AiEditStore);
}
